import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export const PageContainer = ({
  children,
  padding = false,
  className = "",
}: {
  children: ReactNode;
  padding?: boolean;
  className?: string;
}) => {
  return (
    <div
      className={twMerge(
        "mx-auto max-w-[900px] rounded-lg bg-white min-[900px]:mt-[40px]",
        padding && "p-[30px] min-[900px]:p-[60px]",
        className,
      )}
    >
      {children}
    </div>
  );
};
